// import mushroom from "mushroomjs";
import ApiService, { callCustomMethodAsync } from "../service/ApiService";

let moduleApi = {};
let moduleName = "employee";

moduleApi.create = async (dataForm) => {
  let api = {
    module: moduleName,
    type: "create",
    value: dataForm,
    message: {
      success: "hidden",
      error: "hidden"
    }
  };

  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.update = async (dataForm) => {
  let api = {
    module: moduleName,
    type: "partialUpdate",
    value: dataForm,
    message: {
      success: "hidden",
      error: "hidden"
    }
  };

  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.list = async (dataFilter, loading) => {
  let api = {
    module: moduleName,
    type: "list",
    value: dataFilter,
    dontLoading: loading == undefined ? false : loading,
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.delete = async (id) => {
  let api = {
    module: moduleName,
    type: "delete",
    value: { id: id },
    message: {
      success: "Xóa nhân viên thành công!",
      error: "hidden"
    }
  };

  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.findById = async (id, loading) => {
  let api = {
    module: moduleName,
    type: "findById",
    value: { id: id },
    dontLoading: loading == undefined ? false : loading,
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.resetPassword = data => {
  let api = {
    module: moduleName,
    type: "ResetPassword",
    body: data,
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  return callCustomMethodAsync(api);
};

moduleApi.lockUser = async data => {
  let api = {
    module: moduleName,
    type: "LockUser",
    body: data,
    message: {
      success: "Khóa tài khoản thành công!",
      error: "Khóa tài khoản thất bại!"
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom.user.invalidCache();
  return result;
};

moduleApi.unLockUser = async data => {
  let api = {
    module: moduleName,
    type: "UnLockUser",
    body: data,
    message: {
      success: "Mở khóa tài khoản thành công!",
      error: "Mở khóa tài khoản thất bại!"
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom.user.invalidCache();
  return result;
};

moduleApi.ImportExcelEmployee = async data => {
  let api = {
    module: moduleName,
    type: "ImportExcelEmployee",
    body: data,
    message: {
      success: "hidden",
      error: "Nhập dữ liệu nhân viên thất bại!"
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom.user.invalidCache();
  return result;
};

moduleApi.ImportZipEmployee = async data => {
  let api = {
    module: moduleName,
    type: "ImportZipEmployee",
    body: data,
    message: {
      success: "Import nhân viên thành công!",
      error: "Import nhân viên thất bại!"
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom.user.invalidCache();
  return result;
};

moduleApi.getListEmployeeDetail = async (data, loading) => {
  let api = {
    module: moduleName,
    type: "views",
    viewAction: "getListEmployeeDetail",
    value: data,
    dontLoading: loading == undefined ? false : loading
  };
  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.syncEmployees = async (ip) => {
  let api = {
    module: moduleName,
    type: "SyncEmployees",
    body: { device_ip: ip },
    message: {
      success: "Hệ thống sẽ đồng bộ dữ liệu với máy chấm công",
      error: "Đồng bộ nhân viên thất bại!"
    }
  };
  const result = await callCustomMethodAsync(api);
  mushroom.user.invalidCache();
  return result;
};

moduleApi.countEmployees = async () => {
  let api = {
    module: moduleName,
    type: "CountEmployees",
    message: {
      success: "hidden",
      error: "hidden"
    },
    dontLoading: true
  };
  const result = await callCustomMethodAsync(api);
  mushroom.user.invalidCache();
  return result;
};

moduleApi.GetEmployeeHasSignPermission = async (data) => {
  let api = {
    module: moduleName,
    type: "GetEmployeeHasSignPermission",
    body: data,
    message: {
      success: "hidden",
      error: "hidden"
    },
    dontLoading: true
  };
  const result = await callCustomMethodAsync(api);
  mushroom.user.invalidCache();
  return result;
};

moduleApi.GetDirectManagerCandidates = async (data) => {
  let api = {
    module: moduleName,
    type: "GetDirectManagerCandidates",
    body: data,
    message: {
      success: "hidden",
      error: "hidden"
    },
    dontLoading: true
  };
  const result = await callCustomMethodAsync(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.GetListEmployeeHaveBirthdayInMonth = async (data) => {
  let api = {
    module: moduleName,
    type: "GetListEmployeeHaveBirthdayInMonth",
    body: data,
    message: {
      success: "hidden",
      error: "hidden"
    },
    dontLoading: true
  };
  const result = await callCustomMethodAsync(api);
  mushroom.user.invalidCache();
  return result;
};

moduleApi.GetListEmployeeByDepartment = async (data) => {
  let api = {
    module: moduleName,
    type: "GetListEmployeeByDepartment",
    body: data,
    message: {
      success: "hidden",
      error: "hidden"
    },
    dontLoading: true
  };
  const result = await callCustomMethodAsync(api);
  mushroom.user.invalidCache();
  return result;
};

moduleApi.GetEmployeeIdsHaveVTRole = async (data) => {
  let api = {
    module: moduleName,
    type: "GetEmployeeIdsHaveVTRole",
    body: data,
    message: {
      success: "hidden",
      error: "hidden"
    },
    dontLoading: true
  };
  const result = await callCustomMethodAsync(api);
  mushroom.user.invalidCache();
  return result;
};

moduleApi.GetEmployeeByCompanyId = async (data) => {
  let api = {
    module: moduleName,
    type: "GetEmployeeByCompanyId",
    body: data,
    message: {
      success: "hidden",
      error: "hidden"
    },
    dontLoading: true
  };
  const result = await callCustomMethodAsync(api);
  mushroom.user.invalidCache();
  return result;
};

moduleApi.GetEmployeeIdsHaveVTRoleByCompanyId = async (data) => {
  let api = {
    module: moduleName,
    type: "GetEmployeeIdsHaveVTRoleByCompanyId",
    body: data,
    message: {
      success: "hidden",
      error: "hidden"
    },
    dontLoading: true
  };
  const result = await callCustomMethodAsync(api);
  mushroom.user.invalidCache();
  return result;
};

moduleApi.CalcPeriodDetailOfEmployee = async (data) => {
  let api = {
    module: moduleName,
    type: "CalcPeriodDetailOfEmployee",
    body: data,
    message: {
      success: "hidden",
      error: "hidden"
    },
    dontLoading: true
  };
  const result = await callCustomMethodAsync(api);
  mushroom.user.invalidCache();
  return result;
};

moduleApi.syncEmployees = async (ip) => {
  let api = {
    module: moduleName,
    type: "SyncEmployees",
    body: { device_ip: ip },
    message: {
      success: "hidden",
      error: "hidden"
    }
  };
  return callCustomMethodAsync(api);
};

export default moduleApi;

